// services/saleng.js
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import {SALENG_SHOP_API_PROD } from "./../config";

const SALENG_SHOP_API = SALENG_SHOP_API_PROD;

/* ---------------- Helpers: ดึงค่าจาก token ทุกครั้ง ---------------- */
const getAccessToken = () => localStorage.getItem("accessToken") || null;

const decodeToken = () => {
  const token = getAccessToken();
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch {
    return null;
  }
};

const getIds = () => {
  const decoded = decodeToken();
  return {
    accessToken: getAccessToken(),
    userId: decoded?.id ?? null,
    shopId: decoded?.shopId ?? null,
    branchId: decoded?.branchId ?? null,
  };
};

export const getDailyPurchaseSummary = (startDate,endDate) => {
  const { branchId,shopId } = getIds();
  if (!branchId) return Promise.reject("Missing branchId (token?)");
  return axios.get(`${SALENG_SHOP_API}/report/daily-purchase-summary?start=${startDate}&end=${endDate}&branchId=${branchId}&shopId=${shopId}`, {
    headers: { "Content-Type": "application/json" },
  });
};
